import { useApi } from "../../../hooks/useApi";
import { useCallback } from "react";
import { urlReplacer } from "../../../utils";
import { ApiRoutes } from "../../../constants/apiRoutes";

export default function () {
  const { request } = useApi();
  return {
    fetchAll: useCallback(async () => {
      return request({
        method: "GET",
        url: `${ApiRoutes.EXAMS}`,
      });
    }, [request]),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_EXAM, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchCreate: useCallback(
      async (data) => {
        return request({
          data,
          method: "POST",
          url: ApiRoutes.CREATE_EXAM,
        });
      },
      [request],
    ),

    fetchUpdate: useCallback(
      async ({ id, ...data }) => {
        return request({
          data,
          method: "PUT",
          url: urlReplacer(ApiRoutes.UPDATE_EXAM, {
            id,
          }),
        });
      },
      [request],
    ),

    fetchDelete: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_EXAM, { id })}`,
        });
      },
      [request],
    ),
  };
}
